import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PHONE_TEL_LINK, WHATSAPP_LINK, EMAIL, EMAIL_LINK } from "@/constants/business";
import { useDialogs } from "@/context/DialogsContext";

export default function ContactSection() {
  const { requestEstimate } = useDialogs();

  return (
    <section id="contact" data-testid="contact-section" className="py-14 md:py-20 px-4 md:px-8 max-w-7xl mx-auto">
      <div className="bg-navy rounded-3xl px-6 md:px-16 py-12 md:py-16">
        <div className="max-w-2xl">
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-white mb-4">
            Parlons de votre transport
          </h2>
          <p className="text-white/70 text-base leading-relaxed mb-8">
            Décrivez votre besoin en quelques minutes. Nous vous répondrons avec une proposition adaptée, un tarif clair et un créneau organisé.
          </p>

          <div className="flex flex-wrap gap-3 mb-8">
            <Button
              data-testid="contact-estimate-button"
              onClick={() => requestEstimate({ source: "cta-final" })}
              className="bg-orange hover:bg-orange-hover text-white rounded-full px-7 py-6 font-semibold transition-transform hover:-translate-y-0.5"
            >
              Obtenir mon estimation <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-button"
              className="flex items-center gap-2 bg-whatsapp text-white rounded-full px-7 py-3.5 font-semibold hover:brightness-95 transition-all"
            >
              <MessageCircle className="w-4 h-4" /> Envoyer sur WhatsApp
            </a>
            <a
              href={PHONE_TEL_LINK}
              data-testid="contact-call-button"
              className="flex items-center gap-2 bg-white text-navy rounded-full px-7 py-3.5 font-semibold hover:bg-white/90 transition-colors"
            >
              <Phone className="w-4 h-4" /> Appeler maintenant
            </a>
          </div>

          <a href={EMAIL_LINK} data-testid="contact-email-link" className="text-white/60 text-sm hover:text-white transition-colors">
            {EMAIL}
          </a>
        </div>
      </div>
    </section>
  );
}
